import { getPacks } from '../peijian/all'

export default {
  name: 'igs-34',
  // 图文
  imageText: [
    // 主图1
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/buguang/product-igs-34/IGS-34-1.png',
    },
    {
      type: 'formwork9',
      list: [
        {
          id: 'a-1',
          text: '1、Powerful grow lights, talllamp arm, highwater capacity, large grow deck, and detachable trellis',
        },

        { id: 'a-3', text: '2、40 W LED grow light for patent spectrum,optimal lighting' },
        {
          id: 'a-4',
          text: '3、Adjusts for up to 19" of grow height soyou can grow big plants and features alarger bowl to hold more water than the base Harvest',
        },
        { id: 'a-5', text: '4、Machnical swtich illuminated controlpanel & care indicators' },
        { id: 'a-6', text: '5、Easy, automatic reminders for water &plant food' },
      ],
    },
    // 配件 TODO:
    {
      type: 'formwork5',
      packs: getPacks([{ id: 'accessories-17', num: 1 }]),
    },
    // 主图1
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/buguang/product-igs-34/IGS-34-2.png',
    },
    // 参数
    {
      type: 'formwork6',
      specifications: [
        { id: '2-1', name: 'Product Specifications:', value: '370x130x100 mm' },
        { id: '2-2', name: 'Product Weight:', value: '0.9kg' },
        { id: '2-3', name: 'Adapter Specifications Input:', value: '100V-240V/50-60HZ' },
        { id: '2-4', name: 'Output:', value: '5V' },
        { id: '2-5', name: 'Power Rate:', value: '40W' },
        { id: '2-6', name: 'Materials:', value: 'Paint Coated Metal' },
        { id: '2-7', name: 'LED Light:', value: 'Special Spectrum' },
        { id: '2-8', name: 'Lifespan:', value: '>30000 hours' },
        { id: '2-9', name: 'Product Type:', value: 'Grow Light' },
        { id: '2-10', name: 'Special Funciton:', value: 'Lighting /Time Model Switch' },
        { id: '2-11', name: 'Color box Size:', value: '135x100x370mm' },
        { id: '2-12', name: 'Outer box Size:', value: '595x385x410mm' },
      ],
    },
    // 主图3
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/buguang/product-igs-34/IGS-gaungpu-zhuanli.png',
    },
  ],
}
